var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import AntModal from "antd/es/modal";
import classNames from "classnames";
import { useGetGerudoContainer } from "../../hooks/useGetGerudoContainer";
import { ModalType } from "../types";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter/ModalFooter";
// @TODO: remove the New prefix after everyone migrated.
const NewModal = (_a) => {
    var { title, subtitle, actionText, actionType, cancelText, children, className, headerClassName, isCustomRender, loading, onCancel, onAction, centered, visible, asNotification, "data-testid": dataTestId = `${title}` } = _a, props = __rest(_a, ["title", "subtitle", "actionText", "actionType", "cancelText", "children", "className", "headerClassName", "isCustomRender", "loading", "onCancel", "onAction", "centered", "visible", "asNotification", "data-testid"]);
    const { getGerudoContainer } = useGetGerudoContainer();
    const onCancelHandler = () => {
        if (loading)
            return;
        if (onCancel)
            onCancel();
    };
    return (React.createElement(AntModal, Object.assign({ visible: visible, centered: centered, onCancel: onCancelHandler, getContainer: getGerudoContainer }, props, { modalRender: () => {
            if ((isCustomRender || asNotification) && children) {
                return (React.createElement("section", { "data-testid": dataTestId, className: classNames("gerudo-modal-content", "gerudo-modal-content-new", { "gerudo-modal-content-as-notification": asNotification }, className) },
                    title && React.createElement(ModalHeader, { title: title, onCancel: onCancelHandler, loading: loading }),
                    asNotification && (React.createElement("div", { className: classNames("gerudo-circle gerudo-circle-outer", {
                            "as-circle-warning": asNotification.type === ModalType.Warning,
                            "as-circle-info": asNotification.type === ModalType.Info,
                            "as-circle-error": asNotification.type === ModalType.Error,
                        }) },
                        React.createElement("div", { className: classNames("gerudo-circle gerudo-circle-inner") }, asNotification.icon))),
                    React.createElement("div", null, children)));
            }
            return (React.createElement("section", { "data-testid": dataTestId, className: classNames("gerudo-modal-content", "gerudo-modal-content-new", className) },
                React.createElement(ModalHeader, { title: title, subtitle: subtitle, className: headerClassName, onCancel: onCancelHandler, loading: loading }),
                React.createElement("div", { className: "gerudo-modal-body" }, children),
                React.createElement(ModalFooter, { loading: loading, onAction: onAction, actionText: actionText, actionType: actionType, onCancel: onCancelHandler, cancelText: cancelText })));
        } })));
};
NewModal.confirm = AntModal.confirm;
export default NewModal;
export { NewModal };
//# sourceMappingURL=NewModal.js.map